import React, { forwardRef } from 'react';
import { Icon } from '../Icon/Icon.js';
const styles = {"menuItem":"MenuItem-module__menuItem__F2-M-"};
/**
 * One item of a menu (board B2 · "Sign out"): an optional 20 px icon and the label, 44 px tall. The ref reaches the
 * item's button, so a menu can move focus onto it when it opens.
 */
export const MenuItem = forwardRef(function MenuItem({ label, icon, onSelect }, ref) {
    return (React.createElement("button", { ref: ref, className: styles.menuItem, type: "button", role: "menuitem", onClick: onSelect },
        icon !== undefined && React.createElement(Icon, { name: icon, size: 20 }),
        label));
});
//# sourceMappingURL=MenuItem.js.map